/**
 * Logger utility for consistent logging across the application
 * Automatically handles development vs production environments
 */

const isDevelopment = import.meta.env.DEV

/**
 * Log information (only in development)
 */
export const log = (...args) => {
    if (isDevelopment) {
        console.log(...args)
    }
}

/**
 * Log errors (always logged)
 */
export const error = (...args) => {
    console.error(...args)
}

/**
 * Log warnings (only in development)
 */
export const warn = (...args) => {
    if (isDevelopment) {
        console.warn(...args)
    }
}

/**
 * Log debug information (only in development)
 */
export const debug = (...args) => {
    if (isDevelopment) {
        console.debug(...args)
    }
}

/**
 * Log API requests (only in development)
 */
export const logApiRequest = (config) => {
    if (isDevelopment) {
        console.log('🚀 API Request:', {
            method: config.method?.toUpperCase(),
            url: config.url,
            params: config.params,
            data: config.data,
            headers: {
                'x-user-uid': config.headers['x-user-uid'],
                'x-dealership-id': config.headers['x-dealership-id']
            }
        })
    }
}

/**
 * Log API responses (only in development)
 */
export const logApiResponse = (response) => {
    if (isDevelopment) {
        console.log('✅ API Response:', {
            status: response.status,
            url: response.config.url,
            data: response.data,
        })
    }
}

/**
 * Log API errors (always logged)
 */
export const logApiError = (error) => {
    const { response } = error
    
    if (isDevelopment) {
        console.error('❌ API Error:', {
            status: response?.status,
            url: error.config?.url,
            message: error.message,
            data: response?.data,
        })
    } else {
        // In production, only log essential error info
        console.error('API Error:', {
            status: response?.status,
            url: error.config?.url,
            message: error.message,
        })
    }
}

const logger = {
    log,
    error,
    warn,
    debug,
    logApiRequest,
    logApiResponse,
    logApiError
}

export default logger

